import { Component, OnInit, Input } from '@angular/core';
import { Resolution } from 'src/app/shared/models/resolution.model';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-resolution-create-modal',
  templateUrl: './resolution-create-modal.component.html',
  styleUrls: ['./resolution-create-modal.component.scss']
})
export class ResolutionCreateModalComponent implements OnInit {

  resolutionForm: FormGroup;
  @Input() resolution: Resolution;
  isEdit: boolean;

  constructor(public activeModal: NgbActiveModal,
              private formBuilder: FormBuilder) { }

  ngOnInit() {
    this.resolutionForm = this.formBuilder.group({
      resolution_id: [0],
      name         : ['', [Validators.required, Validators.maxLength(25)]],
      width        : ['', Validators.required],
      height       : ['', Validators.required]
    });

    if (this.resolution) {
      this.isEdit = true;
      this.resolutionForm.patchValue({
          resolution_id: this.resolution.resolution_id,
          name         : this.resolution.name,
          width        : this.resolution.width,
          height       : this.resolution.height
        });
    }
  }

  close() {
    this.activeModal.close(
      this.resolutionForm.value
    );
  }
}
